























import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import {
  DimssaButton,
  ButtonState
} from "@/components/shared/dimssa-button.vue";

@Component({
  components: { DimssaButton }
})
export default class Count extends Vue {
}
